import { faExclamationCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button, Modal, ModalBody } from 'reactstrap';
import './index.scss';

const PaymentFailedModal = ({ _modalStatus, _handleModalStatus }) => {
    return (
        <Modal isOpen={_modalStatus} toggle={_handleModalStatus} className="payment-failed-modal" size='sm'>
            <Button color='link' onClick={_handleModalStatus} className='modal-close-btn position-absolute'>
                <FontAwesomeIcon icon={faTimes} />
            </Button>
            <ModalBody>
                <div className='success-info text-center'>
                    <div className="row-cell">
                        <div className="icon">
                            <FontAwesomeIcon icon={faExclamationCircle} />
                        </div>
                        <h2>Payment Failed!</h2>
                        <h3>Reference ID: 149528425282</h3>
                    </div>
                    {/* <div className="row-cell">
                        <Button color='primary'>
                            back to Home page
                        </Button>
                    </div> */}
                </div>
            </ModalBody>
        </Modal>
    );
}

export default PaymentFailedModal;